import { logger } from '@fiverr-private/obs';

export const logError = (component: string, error: string, enrichment?: object) => {
    logger.error(`[${component}] ${error}`, {
        ...enrichment,
    });
};
